import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import leaf from "../../Assets/Projects/leaf.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Fine-tuning"
              description="Llama fine-tuned model using QLoRA on Google Colab. Repository contains notebooks and training configs."
              ghLink="https://github.com/kartikeyapandey20/Fine-tuning"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="transformer-from-scratch"
              description="Educational implementation of a Transformer built from scratch to understand decoder internals and attention mechanisms."
              ghLink="https://github.com/kartikeyapandey20/transformer-from-scratch"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="documind-backend"
              description="Backend for government tender document analysis built with FastAPI. Includes document pipelines and APIs."
              ghLink="https://github.com/kartikeyapandey20/documind-backend"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Codefusion-AI-backend"
              description="Backend for a coding-practice platform that provides insights to improve coding skills; includes API services and evaluation logic."
              ghLink="https://github.com/kartikeyapandey20/Codefusion-AI-backend"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="MiniModernBERT"
              description="Lightweight transformer model and training code (MiniModernBERT) — experiments and fine-tuning artifacts."
              ghLink="https://github.com/kartikeyapandey20/mini-mordern-bert"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Drishtikon-hackaithon"
              description="Backend for Drishtikon — an app for visually impaired users. Contains APIs and helpers built during a hackathon."
              ghLink="https://github.com/kartikeyapandey20/Drishtikon-hackaithon"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
